<template src='./tabRemittanceDetail.pug' lang='pug'></template>

<script scoped>
import moment from 'moment'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'

export default {
  name: 'TabRemittanceDetail',

  components: {
    ButtonPrimary
  },

  props: {
    idModal: {
      type: String
    },
    remittance: {
      type: Object,
      required: true
    },
    showRemovalButton: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    openModalConfirm () {
      $('#confirmRemittanceRemoval').modal('show')
    },

    closeModalConfirm () {
      $('#confirmRemittanceRemoval').modal('hide')
    },

    handleDateFull (text) {
      return text ? moment(text).format('DD/MM/YYYY HH:mm:ss') : '-'
    },

    handleDate (text) {
      return text ? moment(text).format('DD/MM/YYYY') : '-'
    }
  }
}
</script>

<style>
.break-all {
  word-break: break-all;
}
.margin-container {
  margin-top: 15px;
}

.detail-value {
  font-family: 'Inter', sans-serif;
  font-weight: bold;
  color: #012351;
  font-size: 14px;
}

.remittance-detail {
  height: 62vh;
  overflow-y: auto;
}

.tab-footer {
  height: 9vh;
  border-top: 2px solid #d0d0d0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 15px;
}
</style>



// WEBPACK FOOTER //
// TabRemittanceDetail.vue?4f6a4afc